import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import { instance } from '../../services/api';

type IFixedPanel = React.FC<{
  chartName: string;
  endpoint: string;
  textColor: string;
}>;

const FixedPanel: IFixedPanel = ({ textColor, chartName, endpoint }) => {
  const [callback, setCallback] = useState(false);
  const [value, setValue] = useState('');

  const ColorTypography = withStyles({
    root: {
      color: textColor,
      height: 300,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  })(Typography);

  useEffect(() => {
    if (!endpoint || endpoint === '') {
      setValue(chartName);
    } else {
      instance
        .get(endpoint)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            try {
              setValue(res.data[0].result);
            } catch {
              toast.error('Unable to set value on fixed panel');
            }
          }

          setTimeout(() => setCallback(!callback), 7000);
        })
        .then(() => {
          toast.error(`Request to ${endpoint} fail on fixed panel`);
        });
    }
  }, [chartName, callback, endpoint]);

  return (
    <ColorTypography color="inherit" align="center" variant="h1">
      {value}
    </ColorTypography>
  );
};

export default FixedPanel;
